export const GBP = 'GBP'
export const CHF = 'CHF'
export const RSD = 'RSD'
export const EUR = 'EUR'
export const RUB = 'RUB'
export const USD = 'USD'


export const AVAILABLE_CURRENCIES = [GBP, CHF, RSD, EUR, RUB, USD]